import { Box3, Sphere, Vector3 } from "three";

export type CameraPresetId =
  | "front"
  | "top"
  | "leftCenter"
  | "leftEdge"
  | "bottomLeft"
  | "perspective";

export interface CameraPresetResult {
  position: Vector3;
  target: Vector3;
}

const _sphere = new Sphere();
const _center = new Vector3();
const _size = new Vector3();

/**
 * Computes camera position and target for a given bounding box and preset.
 * Uses the same distance formula as fitObjectToPersCamera (FOV-based).
 * Coordinate convention: Y-up, -X left, +Z front.
 */
export function getCameraPresetFromBox(
  box: Box3,
  preset: CameraPresetId,
  fovDeg: number,
  aspect: number
): CameraPresetResult {
  box.getCenter(_center);
  box.getSize(_size);
  box.getBoundingSphere(_sphere);
  const radius = _sphere.radius;
  const fovRad = aspect * fovDeg * (Math.PI / 180) * 1.0;
  const distance = radius / Math.sin(fovRad * 0.5);

  const position = new Vector3();
  const target = new Vector3();

  switch (preset) {
    case "front":
      target.copy(_center);
      position.copy(_center).add(new Vector3(0, 0, distance));
      break;
    case "perspective":
      target.copy(_center);
      position.copy(_center).add(new Vector3(-distance * 0.65, distance * 0.25, distance * 0.55));
      break;
    case "top":
      target.copy(_center);
      position.copy(_center).add(new Vector3(0.0, distance, 0.01));
      break;
    case "leftCenter": {
      // Kamera sol-ön (leftFront) konumda, tam merkeze bakar
      target.copy(_center).add(new Vector3(0,  0.2, 0));
      position.copy(target).add(new Vector3(-distance * 0.3, 0.5, distance * 0.6));
      break;
    }
    case "leftEdge": {
      // Kamera sol-ön (leftFront) konumda, tam merkeze bakar
      target.copy(_center);
      position.copy(_center).add(new Vector3(-distance * 0.5, distance * 0.0, distance * 0.35));
      break;
    }
    case "bottomLeft": {
      // Kamera sol-alt-dışarı (leftBottomDown) konumda, sol-alt noktasına bakar
      /*target.copy(_center);
      position.copy(_center).add(new Vector3(-distance * 0.25, 0, distance * 0.7));*/
      target.copy(_center);
      position.copy(_center).add(new Vector3(0, 0, distance));
      break;
    }
    default:
      target.copy(_center);
      position.copy(_center).add(new Vector3(0, 0, distance));
  }

  return { position, target };
}
